import React from "react";

interface ToggleSwitchProps {
  keyId?: string;
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  type?: string;
  label?: string;
  ariaLabel?: string;
}

const ToggleSwitch = ({
  keyId,
  checked,
  onChange,
  type = "",
  label,
  ariaLabel,
}: ToggleSwitchProps) => {
  const reactId = React.useId();
  const inputId = keyId ? `jf-toggle-${keyId}` : `jf-toggle-${reactId}`;

  return (
    <div className={"jf-toggle-switch " + type}>
      <div className="button r">
        <input
          type="checkbox"
          className="checkbox"
          id={inputId}
          checked={checked}
          onChange={onChange}
          aria-label={ariaLabel || label || "Toggle"}
          name={keyId}
        />
        <div className="knobs" />
        <div className="layer" />
        {label ? (
          <label className="jf-visually-hidden" htmlFor={inputId}>
            {label}
          </label>
        ) : null}
      </div>
    </div>
  );
};

export default ToggleSwitch;
